import { render, staticRenderFns } from "./CpPT.vue?vue&type=template&id=593539d1"
import script from "./CpPT.vue?vue&type=script&lang=js"
export * from "./CpPT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports